import React, { FC, memo } from 'react';
import { MeasurementEntry } from '@higo/common/src/features/ExaminationPage/sections/VitalSignsSection/common/MeasurementEntry';
import { MeasurementSkeleton } from '@higo/common/src/features/ExaminationPage/sections/VitalSignsSection/common/MeasurementSkeleton';
import { MeasurementRenderer } from '@higo/common/src/components/MeasurementRenderer';
import { useTemperaturePhysicalExaminationQuery } from '@higo/common/src/features/ExaminationPage/hooks/queries';

export type TemperatureMeasurementEntryProps = {
  isAvailable?: boolean;
  examinationId: number;
  isVisitSection?: boolean;
  isCanceledStatus?: boolean;
};

export const TemperatureMeasurementEntry: FC<TemperatureMeasurementEntryProps> =
  memo(({ examinationId, isAvailable, isVisitSection, isCanceledStatus }) => {
    const { data, isLoading } = useTemperaturePhysicalExaminationQuery(
      examinationId,
      isAvailable,
    );

    return (
      <MeasurementEntry
        isVisitSection={isVisitSection}
        title="lifeSigns.temperature"
        measurement={
          isLoading ? (
            <MeasurementSkeleton />
          ) : (
            <MeasurementRenderer data={data} />
          )
        }
        isCanceledStatus={isCanceledStatus}
      ></MeasurementEntry>
    );
  });
